export const TimeInput = ({ value, onChange, defaultValue }: any) => {
  const [hours, minutes, period] = value?.split(/[: ]/) || [
    "",
    "",
    defaultValue || "AM",
  ]
  const triggerChange = (newH: string, newM: string, newP: string) => {
    onChange?.(`${newH}:${newM} ${newP}`)
  }

  return (
    <div
      className="flex items-center gap-2 w-full"
      style={{ fontFamily: '"Circular Std", sans-serif' }}
    >
      <input
        value={hours}
        onChange={(e) => triggerChange(e.target.value, minutes, period)}
        placeholder="00"
        maxLength={2}
        className="outline-none text-sm text-center border rounded-md px-3 py-2 w-full"
      />
      <span className="text-sm">:</span>
      <input
        value={minutes}
        onChange={(e) => triggerChange(hours, e.target.value, period)}
        placeholder="00"
        maxLength={2}
        className="outline-none text-sm text-center border rounded-md px-3 py-2 w-full"
      />
      <select
        value={period}
        defaultValue={defaultValue}
        onChange={(e) => triggerChange(hours, minutes, e.target.value)}
        className="outline-none text-sm bg-transparent text-slate-500 border-none"
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  )
}
